import { createContext } from 'react';

export const ThemeCtx = createContext(null);
